// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__ECQLa","title":"Info_title__2s-Ep","links":"Info_links__1brKU","link":"Info_link__1MK-O","logo":"Info_logo__n0I98"};